// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"Exercises_mainDiv__1whYu","exerciseCardsDiv":"Exercises_exerciseCardsDiv__2UcgI","timerContainer":"Exercises_timerContainer__1ecOx"};